import Plot from "react-plotly.js";
import { useTheme } from "../../theme/useTheme";

const Barchart = (props: any) => {
  const { mode } = useTheme();
  const mediumThreshold = 1;
  const highThreshold = 2;

  // Calculate dynamic range based on data
  const minValue = Math.min(...props.yaxis, 0);
  const maxValue = Math.max(...props.yaxis, highThreshold);
  const rangeMin = minValue < 0 ? minValue * 1.1 : 0;
  const rangeMax = Math.ceil(maxValue * 1.1);

  return (
    <Plot
      data={[
        {
          type: "bar",
          orientation: "h", // horizontal bars
          x: props.yaxis, // bar lengths (z-score)
          y: props.xaxis, // bar labels (disease names)
          marker: { color: props.bgcolor },
          width: 0.6, // increase bar thickness (default is 0.8)
          showlegend: false, // hide bar trace from legend
          name: "Z-Score",
          hovertemplate: "<b>%{y}</b><br>Z-Score: %{x:.4f}<extra></extra>",
        },
        // Medium threshold line
        {
          type: "scatter",
          mode: "lines",
          x: [mediumThreshold, mediumThreshold],
          y: [props.xaxis[0], props.xaxis[props.xaxis.length - 1]],
          line: {
            color: "#FFD600",
            width: 3,
            dash: "dash",
          },
          name: "medium",
          showlegend: true,
          hovertemplate:
            "<b>Medium Threshold</b><br>Z-Score: %{x:.1f}<extra></extra>",
        },
        // High threshold line
        {
          type: "scatter",
          mode: "lines",
          x: [highThreshold, highThreshold],
          y: [props.xaxis[0], props.xaxis[props.xaxis.length - 1]],
          line: {
            color: "#D32F2F",
            width: 3,
            dash: "dash",
          },
          name: "high",
          showlegend: true,
          hovertemplate:
            "<b>High Threshold</b><br>Z-Score: %{x:.1f}<extra></extra>",
        },
      ]}
      config={{
        responsive: true,
        displayModeBar: true,
        displaylogo: false,
        modeBarButtons: [["toImage"]],
        modeBarButtonsToRemove: [
          "zoomIn2d",
          "zoomOut2d",
          "resetScale2d",
          "lasso2d",
          "select2d",
          "hoverClosestCartesian",
          "hoverCompareCartesian",
          "sendDataToCloud",
        ],
        toImageButtonOptions: {
          format: "png",
          filename: `${props.title.split(" ").join("_")}_bar_chart`,
        },
      }}
      layout={{
        paper_bgcolor: "rgba(0,0,0,0)",
        plot_bgcolor: "rgba(0,0,0,0)",
        modebar: {
          bgcolor: "rgba(0,0,0,0)",
          color: mode === "dark" ? "#9ca3af" : "#6b7280",
          activecolor: mode === "dark" ? "#e5e7eb" : "#111827",
        },
        xaxis: {
          title: {
            text: props.yaxislabel || "z-score",
            font: { color: mode === "dark" ? "#e5e7eb" : "#111827" },
          },
          showline: true,
          linecolor: mode === "dark" ? "#6b7280" : "#374151",
          linewidth: 2,
          zeroline: true,
          zerolinewidth: 2,
          zerolinecolor: mode === "dark" ? "#6b7280" : "black",
          range: [rangeMin, rangeMax],
          gridcolor: mode === "dark" ? "#374151" : "#e5e7eb",
          tickfont: { color: mode === "dark" ? "#d1d5db" : "#374151" },
        },
        yaxis: {
          automargin: true,
          tickfont: { color: mode === "dark" ? "#d1d5db" : "#374151" },
          showline: true,
          linecolor: mode === "dark" ? "#6b7280" : "#374151",
          linewidth: 2,
          ticklen: 8,
        },
        legend: {
          x: 10,
          y: 0.5,
          font: {
            size: 14,
            color: mode === "dark" ? "#e5e7eb" : "#111827",
          },
        },
        hovermode: "closest",
        margin: { l: 40, r: 0, t: 60, b: 60 },
        autosize: true,
      }}
      style={{ width: "100%", height: "100%" }}
    />
  );
};

export default Barchart;
